import type { StripeElementsOptionsClientSecret } from "@stripe/stripe-js";

const computedStyles = getComputedStyle(document.body);
const baseSpacing = computedStyles.getPropertyValue("--spacing");
const spacing = (factor: number) => `calc(${baseSpacing} * ${factor})`;
const letterSpacing = "-0.02em";

export function useStripeStyles(): StripeElementsOptionsClientSecret {
  return {
    fonts: [
      { cssSrc: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap" },
    ],
    loader: "never",
    appearance: {
      theme: "stripe",
      variables: {
        fontFamily: computedStyles.getPropertyValue("--font-sans"),
        fontSizeBase: "16px",
        tabSpacing: spacing(1),
        gridColumnSpacing: spacing(2),
        gridRowSpacing: spacing(2),
        colorPrimary: computedStyles.getPropertyValue("--color-brand"),
        colorText: computedStyles.getPropertyValue("--color-black"),
        accessibleColorOnColorSuccess: computedStyles.getPropertyValue("--color-success"),
        accessibleColorOnColorDanger: computedStyles.getPropertyValue("--color-error"),
        accessibleColorOnColorWarning: computedStyles.getPropertyValue("--color-warning"),
        colorTextPlaceholder: computedStyles.getPropertyValue("--color-medium-gray"),
        borderRadius: "4px",
      },
      rules: {
        ".Label": {
          fontWeight: computedStyles.getPropertyValue("--text-weight-semibold"),
          fontSize: computedStyles.getPropertyValue("--text-normal"),
          letterSpacing,
        },
        ".Tab": {
          borderColor: computedStyles.getPropertyValue("--color-gray"),
          marginBottom: spacing(2),
        },
        ".PickerItem": {
          borderColor: computedStyles.getPropertyValue("--color-gray"),
        },
        ".Error": {
          fontSize: computedStyles.getPropertyValue("--text-normal"),
          letterSpacing,
        },
        ".Input": {
          padding: `${spacing(2)} ${spacing(3)}`,
          fontSize: computedStyles.getPropertyValue("--text-large"),
          letterSpacing,
          borderColor: computedStyles.getPropertyValue("--color-gray"),
        },
        ".Input::placeholder": {
          color: computedStyles.getPropertyValue("--color-medium-gray"),
        },
      },
    },
  };
}
